import { render, staticRenderFns } from "./DetalhamentoClickGrid.vue?vue&type=template&id=e675eca8"
import script from "./DetalhamentoClickGrid.vue?vue&type=script&lang=js"
export * from "./DetalhamentoClickGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports